import Vue from 'vue'
import Router from 'vue-router'

import EmailDetail from './views/EmailDetail.vue'
import EmailList from './views/EmailList.vue'
import Invoices from './views/Invoices.vue'
import Login from './views/Login.vue'
import LoginOrRedirect from './views/LoginOrRedirect.vue'
import MyInformation from './views/MyInformation.vue'
import MyServices from './views/MyServices.vue'
import WebhotelList from './views/WebhotelList.vue'
import WebhotelDetail from './views/WebhotelDetail.vue'
import MekkeList from './views/MekkeList.vue'
import MekkeDetail from './views/MekkeDetail.vue'
import DomainList from './views/DomainList.vue'
import DomainDetail from './views/DomainDetail.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login-or-redirect',
      component: LoginOrRedirect
    },
    {
      path: '/login/',
      name: 'login',
      component: Login
    },
    {
      path: '/my-services/',
      name: 'my-services',
      component: MyServices
    },
    {
      path: '/my-services/emails/',
      name: 'email-list',
      component: EmailList
    },
    {
      path: '/my-services/emails/:type/:mail',
      name: 'email-detail',
      component: EmailDetail
    },
    {
      path: '/my-services/webhotels/',
      name: 'webhotel-list',
      component: WebhotelList
    },
    {
      path: '/my-services/webhotels/:servername/',
      name: 'webhotel-detail',
      component: WebhotelDetail
    },
    {
      path: '/my-services/mekke/',
      name: 'mekke-list',
      component: MekkeList
    },
    {
      path: '/my-services/mekke/:servername/',
      name: 'mekke-detail',
      component: MekkeDetail
    },
    {
      path: '/my-services/dns/',
      name: 'domain-list',
      component: DomainList
    },
    {
      path: '/my-services/dns/:domain/',
      name: 'domain-detail',
      component: DomainDetail
    },
    {
      path: '/invoices/',
      name: 'invoices',
      component: Invoices
    },
    {
      path: '/my-information/',
      name: 'my-information',
      component: MyInformation
    }
  ]
})
